// extracted by mini-css-extract-plugin
export default {"App":"App_App__kbyNM","Menu":"App_Menu__ndR78","MenuIcon":"App_MenuIcon__eO5Qx","Split":"App_Split__S3xAc","WebViewContainer":"App_WebViewContainer__lsqHm"};